export default "__VITE_ASSET__iNcH41CH__"